module.exports = __webpack_public_path__ + "static/media/BoxPlotQ3_2.9a6ef6ab.svg";